export const GET_FUTURE_APPOINTMENTS_API = `/clinic/get-patient-future-appointments-list`;
export const GET_RESOURCE_LIST_FOR_BOOKING = "/clinic/get-resource-list";
export const GET_RESOURCE_PROCEDURE_LIST = "/clinic/get-procedure";
export const GET_ORDER_ID = "/api/v1/orders";
export const BLOCK_RESOURCE_SLOTS = "/clinic/block-resource-slots";
export const UNBLOCK_RESOURCE_SLOTS = "/clinic/unblock-resource-slots";
export const BOOK_RESOURCE_APPOINTMENT =
  "/api/v1/resource/appointments-booking";
export const UPDATE_CONSULTATION = "api/v1/resource/update-consultation";
export const GET_DOCTOR_LIST = "clinic/get-clinic-doctors";
export const BOOK_DOCTOR_APPOINTMENT =
  "/clinic/book-physical-appointment-add-details";
export const GET_UHID_LIST = (clinic_id) =>
  `/api/v1/${clinic_id}/check_patient_uhid`;
export const CREATE_NEW_ABHA_PATIENT = "clinic/create-patient";
export const UPLOAD_DOCUMENTS = "/api/v1/doctor/upload-document";
export const GET_CITY = "/public/get-city";
export const UPDATE_PATIENT_DETAILS = "public/update-patient-details";
export const PUBLIC_BOOK_ADD_DETAILS =
  "public/book-physical-appointment-add-details";
export const CLINIC_BOOK_ADD_DETAILS =
  "/clinic/book-physical-appointment-add-details";
export const DOCTOR_INCLINIC_ADD = "doctor/inclinic-patient-add";
export const GET_DOCTORS = "clinic/get-clinic-doctors";

export const ENROLL_AADHAR = "/abha/v1/user/enroll";
export const ENROLL_VERIFY_OTP = "/abha/v1/enroll/verify-otp";
export const ENROLL_RESEND_OTP = "/abha/v1/enroll/resend-otp";
export const LINK_MOBILE_NUMBER = "/abha/v1/patients/link-mobile";
export const LINK_MOBILE_NUMBER_OTP = "/abha/v1/patients/verify-otp";
export const LINK_MOBILE_NUMBER_RESEND_OTP = "/abha/v1/patients/resend-otp";
export const ABHA_ADDRESS_SUGGESTION = (patient_id) => {
  return `/abha/v1/patients/${patient_id}/address-suggestion`;
};
export const ABHA_ADD_ADDRESS = (patient_id) => {
  return `/abha/v1/patients/${patient_id}/add-address`;
};
export const DOWNLOAD_ABHA_CARD = (patient_id) => {
  return `/abha/v1/patients/${patient_id}/docu-download`;
};

export const ABHA_PROFILE = (patient_id) => {
  return `/abha/v1/patients/${patient_id}/user-profile`;
};

export const GET_VERIFICATION_REQUEST = "/abha/v1/verification/request";
export const GET_OR_SEND_OTP = "/abha/v1/verification/status";
export const VERIFY_OTP = "/abha/v1/verification/confirm-otp";
export const UPDATE_DEMOGRAPHIC_DETAILS = "/abha/v1/update-demographic-details";

export const GET_OTP_FOR_MOBILE = "/abha/v1/send-otp-mobile-verification";
export const SEND_OTP_FOR_VERIFICATION =
  "/abha/v1/verify-otp-mobile-verification";
export const GET_ABHA_PROFILE_DETAILS =
  "/abha/v1/get-profile-data-mobile-verification";

export const GET_LEAD_PATIENT_DETAILS = "/clinic/get-patient-details";
